import { render, staticRenderFns } from "./CountDownBanner.vue?vue&type=template&id=3b104628&scoped=true&"
import script from "./CountDownBanner.vue?vue&type=script&lang=js&"
export * from "./CountDownBanner.vue?vue&type=script&lang=js&"
import style0 from "./CountDownBanner.vue?vue&type=style&index=0&id=3b104628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b104628",
  null
  
)

export default component.exports